import { Outlet } from 'react-router-dom';
import { useMaxBackButton } from '@/shared/hooks/useMaxBackButton';
import { BottomNav } from '@/widgets/BottomNav';
import styles from './App.module.less';

export function App() {
  useMaxBackButton();

  return (
    <div className={styles.app}>
      <main className={styles.content}>
        <Outlet />
        <div aria-hidden="true" className={styles.bottomSpacer} />
      </main>
      <BottomNav />
    </div>
  );
}
